// extracted by mini-css-extract-plugin
module.exports = {"root":"RequestModal_root__2eR27","title":"RequestModal_title__p8gT4","btn":"RequestModal_btn__2_l-H","card":"RequestModal_card__1RuS6"};